import { render, staticRenderFns } from "./DocumentContentHeader.vue?vue&type=template&id=1c625c51"
import script from "./DocumentContentHeader.vue?vue&type=script&lang=js"
export * from "./DocumentContentHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentHeader.vue?vue&type=style&index=0&id=1c625c51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports